"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CORTEX_ALLOWED_FILE_EXTENSIONS = void 0;
exports.isCortexAllowedFileExtension = isCortexAllowedFileExtension;
exports.getCortexAllowedFileExtensionsWithDot = getCortexAllowedFileExtensionsWithDot;
exports.CORTEX_ALLOWED_FILE_EXTENSIONS = [
    "pdf",
    "md",
    "txt",
    "html",
    "htm",
    "png",
    "jpg",
    "jpeg",
    "svg",
];
function normalizeFileExtension(extension) {
    return extension.trim().toLowerCase().replace(/^\./, "");
}
function isCortexAllowedFileExtension(extension) {
    const normalized = normalizeFileExtension(extension);
    return exports.CORTEX_ALLOWED_FILE_EXTENSIONS.includes(normalized);
}
function getCortexAllowedFileExtensionsWithDot() {
    return exports.CORTEX_ALLOWED_FILE_EXTENSIONS.map((ext) => `.${ext}`);
}
